import React from 'react';

import { Box, Flex } from 'shared/components/display';
import { DefinitionList, ListDetail } from 'shared/components/molecules/DefinitionList';
import Richtext from 'shared/components/Richtext';

import { intl } from 'shared/lib/intl';
import COLORS from 'shared/styles/colors';
import { Scene } from 'shared/typings/briefs';

import styles from './styles';

interface Props {
  scene: Scene;
  sceneNum: number;
}

const ModuleScene: React.FC<Props> = ({ scene, sceneNum }) => {
  return (
    <Box css={styles} className="module-scene">
      <Box className="module-scene__heading">
        <Flex className="module-scene__title" color={COLORS.PRIMARY700}>
          {intl.formatMessage(
            { id: 'SUBHEADING_SCENE_FULL_BRIEF_VIEW' },
            {
              num: sceneNum,
              title: scene.title,
            },
          )}
        </Flex>
      </Box>
      <DefinitionList className="module-scene__content" labelColor={COLORS.NEUTRAL800}>
        <ListDetail
          text="Description"
          hideLabel
          labelClassName="module-scene__label"
          detailsClassName="module-scene__section"
        >
          <Richtext value={JSON.parse(scene.description)} readOnly />
        </ListDetail>
      </DefinitionList>
    </Box>
  );
};

export default ModuleScene;
